<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Informatie over verhuizers</h1>
      <p>
        Heeft u een verhuizing in het vooruitzicht en wilt u graag een
        professioneel verhuisbedrijf inschakelen om uw spullen veilig naar uw
        nieuwe adres te laten verhuizen? Dan biedt Alleverhuizers.nl uitkomst.
        Hier heeft u de mogelijkheid om helemaal gratis offertes aan te vragen
        van verschillende verhuisbedrijven in uw eigen regio. Op die manier kunt
        u in alle rust de tarieven van de verhuizers naast elkaar leggen en
        beslissen met wie u in zee gaat. Verhuizen kan zo tot honderden euro’s
        goedkoper worden!
      </p>

      <h2>Hoe werkt het?</h2>
      <p>
        Het aanvragen van offertes via Alleverhuizers.nl is helemaal kosteloos
        en binnen een mum van tijd gebeurd. Het enige wat u hoeft te doen is het
        invullen van uw gegevens, waarna wij op basis van uw postcode de
        aanvraag sturen naar de dichtstbijzijnde verhuisbedrijven in uw regio.
        Zij stellen naar aanleiding van uw aanvraag een offerte samen, die u
        binnen 24 uur ontvangt. U hoeft deze offertes alleen nog maar naast
        elkaar te leggen en bepaalt natuurlijk helemaal zelf door wie u uw
        spullen laat verhuizen. Zo voorkomt u dat u meteen een onnodig duur
        verhuisbedrijf kiest, terwijl u ergens anders veel voordeliger uit had
        kunnen zijn. Kortom: eerst vergelijken, daarna pas verhuizen!
      </p>

      <h2>Voordelig verhuizen?</h2>
      <p>
        Verhuizen is al duur genoeg, of het nu gaat om een particuliere
        verhuizing, zakelijke verhuizing of internationale verhuizing; elke
        mogelijkheid om te besparen op uw verhuizing is mooi meegenomen, vooral
        als het gaat om aanzienlijke bedragen. Maakt u het zichzelf niet
        moeilijker dan nodig is én houd euro’s over door gratis offertes te
        vergelijken van <nuxt-link to="/"> verhuisbedrijven </nuxt-link> in uw
        omgeving. Vul vandaag nog uw gegevens in op Alleverhuizers.nl en ontvang
        de volgende dag al meerdere offertes!
      </p>

      <h2>Regio's</h2>
      <ul>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/amsterdam">
            Verhuizers in Amsterdam
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/rotterdam">
            Verhuizers in Rotterdam
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/den-haag">
            Verhuizers in Den Haag
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/utrecht">
            Verhuizers in Utrecht
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/groningen">
            Verhuizers in Groningen
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/haarlem">
            Verhuizers in Haarlem
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/almere">
            Verhuizers in Almere
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/nijmegen">
            Verhuizers in Nijmegen
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/eindhoven">
            Verhuizers in Eindhoven
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/tilburg">
            Verhuizers in Tilburg
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Informatie over verhuizers',
      headDescription:
        'Meer informatie over Alleverhuizers.nl vind je op deze informatie pagina.',
    }
  },
}
</script>
